import type { SVGProps } from 'react';

export interface NoItemIconProps extends Omit<SVGProps<SVGSVGElement>, 'xmlns' | 'children'> {}

const NoItemIcon = ({ width = '20', height = '20', ...rest }: NoItemIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    fill="none"
    width={width}
    height={height}
    aria-hidden={true}
    focusable="false"
    {...rest}
  >
    <rect x="0.5" y="0.5" width="21" height="21" rx="10.5" fill="#008EDC" />
    <rect x="0.5" y="0.5" width="21" height="21" rx="10.5" fill="none" stroke="#D9534F" />
    <path
      d="M13.6034 4.76818C13.6805 4.74013 13.7095 4.73221 13.6806 4.83702C13.6769 4.96644 13.6169 5.10808 13.5946 5.23217C13.4674 5.94278 13.3772 6.70124 13.371 7.42648C13.3684 7.74504 13.3987 8.06395 13.4027 8.38251C13.4129 8.44481 13.4149 8.50798 13.409 8.57234L13.4181 8.55462C13.4393 8.82034 13.4817 9.13013 13.5262 9.39792L13.5417 9.48397C13.8207 11.0756 14.4732 12.5873 15.355 13.8487L15.75 14.3373H15.2018C15.1664 14.3373 14.6952 13.9316 14.6307 13.8722C13.1505 12.5071 12.244 10.4878 12.0205 8.36547C11.9669 8.41642 11.9058 8.47614 11.8592 8.53379C11.0679 9.51288 10.3717 10.6124 9.8698 11.8025C9.68989 12.229 9.51354 12.6722 9.41841 13.1326C9.67738 13.0098 9.94254 12.8983 10.218 12.8278C11.1357 12.5927 12.1282 12.6951 13.0046 12.9995L13.2634 13.1152C13.1329 13.1208 13.0027 13.1472 12.8745 13.1723C10.4994 13.6387 8.49199 15.1484 7.04004 17.2286C7.00051 17.2773 6.99032 17.2429 7.00916 17.1253C7.01456 16.6285 7.21656 15.7533 7.3225 15.2458C8.00615 11.9715 9.62704 7.86879 12.0249 5.73265C12.3546 5.43904 13.1961 4.80467 13.6036 4.76818H13.6034Z"
      fill="white"
    />
    <path
      d="M11 21C16.5137 21 21 16.5141 21 11C21 8.32666 19.9604 5.81506 18.0726 3.92745C16.1845 2.03963 13.6733 1 11 1C5.48588 1 1 5.48588 1 11C1 13.6733 2.03963 16.1849 3.92745 18.0726C5.81506 19.9604 8.32666 21 11 21ZM11 19.3333C9.05257 19.3333 7.20829 18.6713 5.72412 17.4543L17.4543 5.72412C18.6713 7.20829 19.3333 9.05257 19.3333 11C19.3333 15.5949 15.5949 19.3333 11 19.3333ZM11 2.66667C12.947 2.66667 14.7917 3.32869 16.2755 4.54574L4.54574 16.2759C3.32869 14.7917 2.66667 12.9474 2.66667 11C2.66667 6.40507 6.40507 2.66667 11 2.66667Z"
      fill="#D9534F"
    />
  </svg>
);

export default NoItemIcon;
